// // Vaanmathi
// import React, { useState, useEffect } from "react";
// import {
//   FaHistory,
//   FaExpand,
//   FaCompress,
//   FaQuestionCircle,
//   FaSignOutAlt,
//   FaUserPlus,
//   FaBars,
// } from "react-icons/fa";
// import { useNavigate } from "react-router-dom";

// const getCurrentUserInfo = () => {
//   return {
//     userId: localStorage.getItem("userId") || sessionStorage.getItem("userId"),
//     userName:
//       localStorage.getItem("userName") || sessionStorage.getItem("userName"),
//     userMobile:
//       localStorage.getItem("userMobile") ||
//       sessionStorage.getItem("userMobile"),
//     role: localStorage.getItem("role") || sessionStorage.getItem("role"),
//     userEmail:
//       localStorage.getItem("userEmail") || sessionStorage.getItem("userEmail"),
//     userFullName:
//       localStorage.getItem("userFullName") ||
//       sessionStorage.getItem("userFullName"),
//   };
// };

// const Navbar = ({
//   onToggleSidebar,
//   sidebarOpen = true,
//   currentUser,
//   isMobile,
//   onHamburgerClick,
// }) => {
//   const [showUserMenu, setShowUserMenu] = useState(false);
//   const [fullScreen, setFullScreen] = useState(false);
//   const navigate = useNavigate();
//   // eslint-disable-next-line
//   const userInfo = getCurrentUserInfo();
//   // const displayName = currentUser || userInfo?.userName || 'Admin';

//   const uniqueActiveColors = {
//     electricBlue: "#1e3147",
//   };

//   const selectedActiveColor = uniqueActiveColors.electricBlue;

//   // Fullscreen functionality
//   const toggleFullScreen = () => {
//     const elem = document.documentElement;

//     if (!document.fullscreenElement) {
//       elem.requestFullscreen().then(() => setFullScreen(true));
//     } else {
//       document.exitFullscreen().then(() => setFullScreen(false));
//     }
//   };

//   const handleFullscreenChange = () => {
//     setFullScreen(!!document.fullscreenElement);
//   };

//   useEffect(() => {
//     document.addEventListener("fullscreenchange", handleFullscreenChange);

//     return () => {
//       document.removeEventListener("fullscreenchange", handleFullscreenChange);
//     };
//   }, []);

//   const handleLogout = () => {
//     localStorage.removeItem("userId");
//     localStorage.removeItem("userName");
//     localStorage.removeItem("userMobile");
//     localStorage.removeItem("role");
//     localStorage.removeItem("userEmail");
//     localStorage.removeItem("userFullName");

//     sessionStorage.removeItem("userId");
//     sessionStorage.removeItem("userName");
//     sessionStorage.removeItem("userMobile");
//     sessionStorage.removeItem("role");
//     sessionStorage.removeItem("userEmail");
//     sessionStorage.removeItem("userFullName");

//     console.log("User logged out and session cleared");

//     navigate("/signIn");
//   };

//   const handleUserMenuClick = (item) => {
//     if (item === "logout") {
//       handleLogout();
//     } else if (item === "help") {
//       console.log("Opening help...");
//     }
//     setShowUserMenu(false);
//   };

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (showUserMenu && !event.target.closest(".admin-dropdown")) {
//         setShowUserMenu(false);
//       }
//     };

//     document.addEventListener("click", handleClickOutside);
//     return () => {
//       document.removeEventListener("click", handleClickOutside);
//     };
//   }, [showUserMenu]);

//   return (
//     <>
//       <link rel="preconnect" href="https://fonts.googleapis.com" />
//       <link
//         rel="preconnect"
//         href="https://fonts.gstatic.com"
//         crossOrigin="true"
//       />
//       <link
//         href="https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600;700;800;900&display=swap"
//         rel="stylesheet"
//       />

//       <nav
//         className="navbar navbar-expand-lg navbar-dark position-fixed w-100"
//         style={{
//           zIndex: 1055,
//           top: 0,
//           left: 0,
//           minHeight: "65px",
//           background: selectedActiveColor,
//           boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
//         }}
//       >
//         <div className="container-fluid d-flex align-items-center justify-content-between">
//           {/* Left Section: Hamburger + Title */}
//           <div className="d-flex align-items-center">
//             <button
//               className="btn border-0 p-2 icon-hover me-2"
//               type="button"
//               onClick={isMobile ? onHamburgerClick : onToggleSidebar}
//               style={{ zIndex: 1060 }}
//             >
//               <FaBars className="text-white" style={{ fontSize: "1.5rem" }} />
//             </button>
            
//             <h4
//               className="text-white mb-0"
//               style={{
//                 fontFamily: `'Times New Roman', sans-serif`,
//                 fontWeight: 700,
//                 fontSize: isMobile ? "1.1rem" : "1.9rem",
//                 letterSpacing: "1px",
//               }}
//             >
//               PAYROLL DASHBOARD
//             </h4>
//           </div>

//           {/* Right Section: Icons + Admin Dropdown */}
//           <div className="d-flex align-items-center">
//             {/* Icons Section */}
//             <div className="d-flex align-items-center me-3">
//               {/* Optional: Add back the registration button if needed */}
//               {/* <button 
//                 className="btn p-2 me-2 border-0 rounded-circle icon-hover" 
//                 onClick={() => navigate("/empregistration")}
//                 title="View Registration"
//               >
//                 <FaUserPlus className="text-white" />
//               </button> */}

//               <button
//                 className="btn p-2 me-2 border-0 icon-hover"
//                 onClick={() => navigate("/history")}
//                 title="View History"
//               >
//                 <FaHistory className="text-white" />
//               </button>
              
//               <button
//                 className="btn p-2 me-2 border-0 icon-hover"
//                 onClick={toggleFullScreen}
//                 title={fullScreen ? "Exit Fullscreen" : "Enter Fullscreen"}
//               >
//                 {fullScreen ? (
//                   <FaCompress className="text-white" />
//                 ) : (
//                   <FaExpand className="text-white" />
//                 )}
//               </button>
//             </div>

//             {/* Vertical Line - Hidden on mobile for space efficiency */}
//             {!isMobile && (
//               <div
//                 className="me-3"
//                 style={{
//                   width: "1px",
//                   height: "30px",
//                   backgroundColor: "rgba(255,255,255,0.3)",
//                 }}
//               ></div>
//             )}

//             {/* Admin Dropdown */}
//             <div className="position-relative admin-dropdown">
//               <button
//                 className="btn btn-link text-white fw-bold p-2 me-2 text-decoration-none d-flex align-items-center icon-hover"
//                 onClick={() => setShowUserMenu(!showUserMenu)}
//                 style={{
//                   border: "none",
//                   background: "none",
//                   fontSize: "1rem",
//                 }}
//               >
//                 Admin
//                 <i
//                   className={`ms-1 ${
//                     showUserMenu ? "bx bx-chevron-up" : "bx bx-chevron-down"
//                   }`}
//                   style={{ fontSize: "0.8rem" }}
//                 ></i>
//               </button>

//               {showUserMenu && (
//                 <div
//                   className="dropdown-menu dropdown-menu-end show border-0 main-header-dropdown overflow-hidden header-profile-dropdown"
//                   style={{
//                     position: "absolute",
//                     top: "100%",
//                     right: 0,
//                     width: "130px",
//                     height: "130px",
//                     zIndex: 1060,
//                     backgroundColor: "#fff",
//                     borderRadius: "0px",
//                     boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)",
//                     marginTop: "27px",
//                     display: "flex",
//                     flexDirection: "column",
//                     justifyContent: "center",
//                   }}
//                 >
//                   <ul className="list-unstyled mb-0">
//                     <li className="border-0">
//                       <button
//                         className="dropdown-item d-flex align-items-center py-2 px-3 border-0 bg-transparent w-100 text-start"
//                         onClick={() => handleUserMenuClick("help")}
//                         style={{
//                           transition: "background-color 0.15s ease-in-out",
//                           cursor: "pointer",
//                         }}
//                       >
//                         <FaQuestionCircle className="text-dark me-2" />
//                         Help
//                       </button>
//                     </li>
//                     <li className="border-0">
//                       <button
//                         className="dropdown-item d-flex align-items-center py-2 px-3 border-0 bg-transparent w-100 text-start"
//                         onClick={() => handleUserMenuClick("logout")}
//                         style={{
//                           transition: "background-color 0.15s ease-in-out",
//                           cursor: "pointer",
//                         }}
//                       >
//                         <FaSignOutAlt className="text-dark me-2" />
//                         Log Out
//                       </button>
//                     </li>
//                   </ul>
//                 </div>
//               )}
//             </div>
//           </div>
//         </div>
//       </nav>
//       <style>{`
//   .icon-hover:hover svg {
//     transform: scale(1.2);
//     transition: transform 0.2s;
//   }
//   .dropdown-item.d-flex.align-items-center.py-2.px-3.border-0.bg-transparent.w-100.text-start:hover {
//     background-color: transparent !important;
//   }
// `}</style>
//     </>
//   );
// };

// export default Navbar;



// Updated By Maran - 04.10.2025
import React, { useState, useEffect } from "react";
import {
  FaHistory,
  FaExpand,
  FaCompress,
  FaQuestionCircle,
  FaSignOutAlt,
  FaBars,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const getCurrentUserInfo = () => {
  return {
    userId: localStorage.getItem("userId") || sessionStorage.getItem("userId"),
    userName:
      localStorage.getItem("userFullName") || sessionStorage.getItem("userFullName"),
    userMobile:
      localStorage.getItem("userMobile") ||
      sessionStorage.getItem("userMobile"),
    role: localStorage.getItem("role") || sessionStorage.getItem("role"),
    userEmail:
      localStorage.getItem("userEmail") || sessionStorage.getItem("userEmail"),
    userFullName:
      localStorage.getItem("userFullName") ||
      sessionStorage.getItem("userFullName"),
  };
};

const Navbar = ({
  onToggleSidebar,
  sidebarOpen = true,
  currentUser,
  isMobile,
  onHamburgerClick,
}) => {
  const [showUserMenu, setShowUserMenu] = useState(false);
  const [fullScreen, setFullScreen] = useState(false);
  const navigate = useNavigate();
  const userInfo = getCurrentUserInfo();

  const selectedActiveColor = "#1e3147";

  // Calculate toggleLeft based on sidebar state for desktop
  const toggleLeft = !isMobile ? (sidebarOpen ? "240px" : "70px") : "0px";

  // Fullscreen functionality
  const toggleFullScreen = () => {
    const elem = document.documentElement;

    if (!document.fullscreenElement) {
      elem.requestFullscreen().then(() => setFullScreen(true));
    } else {
      document.exitFullscreen().then(() => setFullScreen(false));
    }
  };

  const handleFullscreenChange = () => {
    setFullScreen(!!document.fullscreenElement);
  };

  useEffect(() => {
    document.addEventListener("fullscreenchange", handleFullscreenChange);
    return () => {
      document.removeEventListener("fullscreenchange", handleFullscreenChange);
    };
  }, []);

  const handleLogout = () => {
    sessionStorage.clear()
    localStorage.clear()
    navigate("/signIn");
  };

  const handleUserMenuClick = (item) => {
    if (item === "logout") {
      handleLogout();
    } else if (item === "help") {
      console.log("Opening help...");
      // navigate('/help');
    }
    setShowUserMenu(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showUserMenu && !event.target.closest(".admin-dropdown")) {
        setShowUserMenu(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [showUserMenu]);

  return (
    <>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link
        rel="preconnect"
        href="https://fonts.gstatic.com"
        crossOrigin="true"
      />
      <link
        href="https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600;700;800;900&display=swap"
        rel="stylesheet"
      />

      <nav
        className="navbar navbar-expand-lg navbar-dark position-fixed w-100"
        style={{
          zIndex: 1055,
          top: 0,
          left: 0,
          minHeight: "67px",
          background: selectedActiveColor,
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
          padding: "0",
          transition: "all 0.3s ease-in-out",
        }}
      >
        <div className="container-fluid d-flex align-items-center justify-content-between px-3">
          {/* Left Section: Sidebar Toggle + Title */}
          <div className="d-flex align-items-center justify-content-between col-7">
            <button
              className="btn border-0 p-2 icon-hover me-2"
              type="button"
              onClick={isMobile ? onHamburgerClick : onToggleSidebar}
              style={{ 
                zIndex: 1060,
                marginLeft: isMobile ? "0px" : (sidebarOpen ? "240px" : "70px"),
                transition: "margin-left 0.3s ease-in-out"
              }}
              aria-label={isMobile ? "Open menu" : "Toggle sidebar"}
            >
              <FaBars className="text-white" style={{ fontSize: "1.1rem" }} />
            </button>
            
            <h4
              className="text-white mb-0 d-flex flex-wrap"
              style={{
                fontFamily: `'Cinzel', 'Times New Roman', serif`,
                fontWeight: isMobile ? 600 : 700,
                fontSize: isMobile ? "0.8rem" : "1.4rem",
                letterSpacing: "1px",
                margin: 0
              }}
            >
              PAYROLL DASHBOARD
            </h4>
          </div>

          {/* Right Section: Actions + User Menu */}
          <div className="d-flex align-items-center justify-content-end col-4">
            {/* Action Buttons */}
            <div className="d-flex align-items-center me-2">
              {/* <button
                className="btn p-2 border-0 icon-hover me-2"
                onClick={() => navigate("/history")}
                title="View History"
                aria-label="View History"
                style={{ 
                  borderRadius: "6px",
                  transition: "background-color 0.2s"
                }}
              >
                <FaHistory className="text-white" style={{ fontSize: "1.1rem" }} />
              </button> */}

              <button
                className="btn p-2 border-0 d-none d-md-block icon-hover me-2"
                onClick={toggleFullScreen}
                title={fullScreen ? "Exit Fullscreen" : "Enter Fullscreen"}
                aria-label={fullScreen ? "Exit Fullscreen" : "Enter Fullscreen"}
                style={{ 
                  borderRadius: "6px",
                  transition: "background-color 0.2s"
                }}
              >
                {fullScreen ? (
                  <FaCompress className="text-white" style={{ fontSize: "1.1rem" }} />
                ) : (
                  <FaExpand className="text-white" style={{ fontSize: "1.1rem" }} />
                )}
              </button>
            </div>

            {/* Vertical Divider - Hide on very small screens */}
            {!isMobile || window.innerWidth > 480 ? (
              <div
                className="me-3"
                style={{
                  width: "1px",
                  height: "30px",
                  backgroundColor: "rgba(255,255,255,0.3)",
                }}
              ></div>
            ) : null}

            {/* User Dropdown */}
            <div className="position-relative admin-dropdown">
              <button
                className="btn btn-link text-white fw-bold p-2 text-decoration-none d-flex align-items-center icon-hover"
                onClick={() => setShowUserMenu(!showUserMenu)}
                style={{
                  border: "none",
                  background: "none",
                  fontSize: isMobile ? "0.9rem" : "1rem",
                  borderRadius: "6px",
                  transition: "background-color 0.2s",
                  whiteSpace: "nowrap"
                }}
                aria-haspopup="true"
                aria-expanded={showUserMenu}
              >
                {currentUser || userInfo?.userName || 'Admin'}
                <i
                  className={`ms-1 ${
                    showUserMenu ? "bx bx-chevron-up" : "bx bx-chevron-down"
                  }`}
                  style={{ fontSize: "0.8rem" }}
                ></i>
              </button>

              {showUserMenu && (
                <div
                  className="dropdown-menu dropdown-menu-end show border-0"
                  style={{
                    position: "absolute",
                    top: "100%",
                    right: 0,
                    width: "140px",
                    zIndex: 1060,
                    backgroundColor: "#fff",
                    borderRadius: "8px",
                    boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)",
                    marginTop: "8px",
                    padding: "4px 0",
                    overflow: "hidden"
                  }}
                >
                  <button
                    className="dropdown-item d-flex align-items-center py-2 px-3 border-0 bg-transparent w-100 text-start"
                    onClick={() => navigate("/howToUse")}
                    style={{
                      transition: "background-color 0.15s ease-in-out",
                      cursor: "pointer",
                      fontSize: "0.9rem"
                    }}
                  >
                    <FaQuestionCircle className="text-dark me-2" />
                    How To Use
                  </button>
                  <button
                    className="dropdown-item d-flex align-items-center py-2 px-3 border-0 bg-transparent w-100 text-start"
                    onClick={() => handleUserMenuClick("logout")}
                    style={{
                      transition: "background-color 0.15s ease-in-out",
                      cursor: "pointer",
                      fontSize: "0.9rem"
                    }}
                  >
                    <FaSignOutAlt className="text-dark me-2" />
                    Log Out
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>

      <style>{`
        .icon-hover:hover {
          background-color: rgba(255, 255, 255, 0.1) !important;
        }
        .icon-hover:hover svg {
          transform: scale(1.1);
          transition: transform 0.2s;
        }
        .dropdown-item.d-flex.align-items-center.py-2.px-3.border-0.bg-transparent.w-100.text-start:hover {
          background-color: #f8f9fa !important;
        }
        
        @media (max-width: 768px) {
          .container-fluid {
            padding-left: 12px !important;
            padding-right: 12px !important;
          }
        }
        
        @media (max-width: 480px) {
          h4 {
            font-size: 1rem !important;
          }
          .navbar .btn {
            padding: 6px !important;
          }
        }

        @media (max-width: 360px) {
          h4 {
            font-size: 0.9rem !important;
          }
        }
      `}</style>
    </>
  );
};

export default Navbar;